<template>
  <div v-if="Math.ceil(daysTillGoal) < 30" :class="['msg', 'icon', 'warning']">
    <div class="icon">
      <awesomeIcon icon="info-circle"/>
    </div>
    <div class="alertText">
      <b>
      Uw looptijd is {{ Math.ceil(daysTillGoal) < 1 ? '' : 'bijna ' }}verstreken
      ({{new Date(currentPort.target_date).toLocaleDateString()}})
      </b><br />
      U blijft belegd binnen het huidige profiel, maar wellicht wilt u uw looptijd
      verlengen. Klik op de knop om uw klantprofiel te openen en uw looptijd aan te passen.
      Heeft u vragen of hulp nodig, klik dan op 'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>
</template>
<script>
export default {
  name: 'oxbyGoalAlerts',
  props: {
    currentPort: Object,
  },
  computed: {
    daysTillGoal() {
      return (
        (new Date(this.currentPort.target_date)).getTime()
        - (new Date()).getTime()
      ) / 1000 / 24 / 60 / 60;
    },
  },
};
</script>
